export default "__VITE_ASSET__Cxs7vGqb__"